import axios from 'axios';
import Vue from 'vue';   
import cookieHelper from '@/helpers/cookie/cookie'; 

window.cookieBridge = new cookieHelper;

class AxiosInstance {
    constructor(axios, vue) {
        this.axios = axios;
        this.vue = vue;
        this.cookieBridge = window.cookieBridge;

        this.instance = {}
        this.headers = {};
        this.params = null;
  
        this.init();
    }

    init() {
        const params = {};
        let status = false; 
   
        if(this.isExpired()) {             
            const path =  location.pathname.split('/')[1];
             
            if(path != 'login') {  
                this.redirect('/login')
            }    
        }  
        else {    
            status = true;
            params.access_token = this.cookieBridge.getCookie('access_token');
            params.refresh_token = this.cookieBridge.getCookie('refresh_token'); 
            params.expires_in = this.cookieBridge.getCookie('expires_in'); 
        }  
        this.setToken(status, params); 
    }

    async get(url) {   
        if(!await this.authCheck()) { 
            return;
        };   
     
        return await this.instance.get(url, {
            headers: {
                'Authorization': `Bearer ${this.cookieBridge.getCookie('access_token')}`
            }
        });
    }

    async post(url, form) {   
        return await this.instance.post(url, form, {
            headers: {
                'Authorization': `Bearer ${this.cookieBridge.getCookie('access_token')}`
            }
        });
    }

    async delete(url) {  
        return await this.instance.delete(url, {
            headers: {
                'Authorization': `Bearer ${this.cookieBridge.getCookie('access_token')}`
            }
        });
    } 

    setToken(type = false, params) {  
        let change = type;
        if(change) {
            this.params = params;   
            this.setCookie();
        }   
  
        this.build();
    } 
    
    catchError() {
        this.instance.interceptors.response.use(response => {
            return response;
        }, error => {    
           if (error.response.status === 401) {  
                this.clearCookies();  
                
                location.href = '/login';
           }

           return error.response;
        });

        // this.instance.interceptors.request.use( async config => {
        //         return config;
        //     }, error => {
        //         return error;
        //     } 
        // );
    }

    build() {
        const headers = this.headers;  
        
        this.instance = this.axios.create({
            baseURL: this.vue.prototype.$config.apiUrl
        });  
        this.catchError(); 
    }   

    async refreshToken() {
        const response = await this.post('/simulator/refresh_token', {
            refresh_token: this.cookieBridge.getCookie('refresh_token')
        });
       
        if(response.status === 200) {     
            this.setToken(true, response.data);
        }
    }

    setCookie() { 
        this.clearCookies();

        document.cookie = `access_token=${this.params.access_token}; max-age=${this.params.expires_in}; path=/;`;
        document.cookie = `refresh_token=${this.params.refresh_token}; path=/;`; 
        document.cookie = `expires_in=${this.params.expires_in}; path=/;`; 
    }

    async authCheck() {  
        if(this.isExpired()) {    
            this.redirect('/login');
        }
        
        if(this.canRefresh()) {  
            await this.refreshToken(); 
            return true;
        }
         
        return true; 
    }

    clearCookies() {
        this.cookieBridge.deleteCookie('access_token');
        this.cookieBridge.deleteCookie('refresh_token');  
        this.cookieBridge.deleteCookie('expires_in');  
    }

    redirect(url) {
        location.href = url;
    }

    isExpired() {
        return this.cookieBridge.getCookie('access_token') == undefined && this.cookieBridge.getCookie('refresh_token') == undefined;
    }

    canRefresh() {
        return this.cookieBridge.getCookie('access_token') == undefined && this.cookieBridge.getCookie('refresh_token') != undefined;
    }
};  
   
export function init() {
    return new AxiosInstance(axios, Vue);
}  